import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import siTroubleshootingFile from "../../../assets/markDownFiles/si/troubleshooting.md";

const SiTroubleshooting = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (typeof siTroubleshootingFile === "string" && siTroubleshootingFile.startsWith("/static")) {
       fetch(siTroubleshootingFile)
      .then((res) => res.text())
      .then((raw) => {
        console.log(JSON.stringify(raw.slice(0, 200))); 
        setContent(convertMdxToMd(raw));
      });
         
    } else {
      console.log(JSON.stringify(siTroubleshootingFile.slice(0, 200)));
      setContent(convertMdxToMd(siTroubleshootingFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT Sports Integrity
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default SiTroubleshooting;

